<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Erişim Kayıtları</h3>

    </div>

    <v-app>
      <v-data-table
          :headers="headers"
          :items="accessLogsResponse.items"
          :items-per-page="100"
          class="elevation-1"
          :search="search">
        <template v-slot:top>
          <v-text-field
              v-model="search"
              label="Arama"
              class="mx-4"/>
        </template>
        <template v-slot:item.userId="{ item }">
          <tr style="width: 50px!important;">
            {{getUserName(item.userId)}}
          </tr>
        </template>
        <template v-slot:item.createDate="{ item }">
          <tr style="width: 50px!important;">
            {{createDate | ddMMyyyyHHmm }}
          </tr>
        </template>
      </v-data-table>
    </v-app>
    <div class="section-block mb-4"></div>
  </div>
</template>

<script>
export default {
  name: "RoleRightList",
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'id',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        {
          text: 'user_id',
          sortable: true,
          value: 'userId'
        },
        {
          text: 'url',
          sortable: true,
          value: 'url'
        },
        {
          text: 'role',
          sortable: true,
          value: 'role'
        },
        {
          text: 'token',
          sortable: true,
          value: 'token'
        },
        {
          text: 'execution_time',
          sortable: true,
          value: 'executionTime'
        },
        {
          text: 'create_date',
          sortable: true,
          value: 'createDate'
        },
        {
          text: 'request',
          sortable: true,
          value: 'request',
        },
        {
          text: 'response',
          sortable: true,
          value: 'response'
        },
      ]
    }
  },
  computed:{
    accessLogsResponse : {
      get(){
        return this.$store.getters.getAccessLogsResponse;
      }
    },
    userListMap:{
      get(){
        return this.$store.getters.getUserListMap;
      }
    },
  },
  methods:{
    filterCruiseRooms (value, search, item) {
    },
    getUserName(userId){
      if(!this.userListMap || userId === 0) return "";

      return this.userListMap[userId].email;
    }
  },
  mounted() {
    this.$store.dispatch("loadUserList");
  }
}
</script>

<style scoped>

</style>